import { t } from '@lingui/macro'
import { Form, Formik, FormikValues } from 'formik'
import { useEffect, useState } from 'react'
import { object, string } from 'yup'

import { Button, Input } from '@/components'
import { ErrorMessages, Storage } from '@/constants'

const signupSchema = object().shape({
  firstName: string().required(ErrorMessages.REQUIRED_FIELD),
  lastName: string().required(ErrorMessages.REQUIRED_FIELD),
  professionalUrl: string(),
})

type Props = {
  nextStep: () => void
}

const Signup: React.FC<React.PropsWithChildren<Props>> = ({ nextStep }) => {
  const [initialValues, setInitialValues] = useState({
    firstName: '',
    lastName: '',
    professionalUrl: '',
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone ?? 'N/A',
  })

  const handleSubmit = (values: FormikValues): void => {
    localStorage.setItem(Storage.APPLY_USER_DATA, JSON.stringify(values))

    nextStep()
  }

  useEffect(() => {
    const localStorageData = localStorage.getItem(Storage.APPLY_USER_DATA)

    if (localStorageData) {
      setInitialValues(JSON.parse(localStorageData))
    }
  }, [])

  return (
    <Formik initialValues={initialValues} validationSchema={signupSchema} onSubmit={handleSubmit} enableReinitialize>
      {({ isSubmitting }) => (
        <Form>
          <div className="grid grid-cols-2 gap-x-6 gap-y-8">
            <div className="xs:col-span-1 col-span-2">
              <Input name="firstName" label={t`First name`} />
            </div>

            <div className="xs:col-span-1 col-span-2">
              <Input name="lastName" label={t`Last name`} />
            </div>

            <div className="col-span-2">
              <Input
                name="professionalUrl"
                label={t`Your professional URL`}
                placeholder="e.g. LinkedIn, Twitter, website"
              />
            </div>

            <div className="col-span-2">
              <Button type="submit" variant="primary" disabled={isSubmitting} loading={isSubmitting} block>
                {isSubmitting ? t`Please wait ...` : t`Next step`}
              </Button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  )
}

export default Signup
